const TabGrowtools = () => {
   return (
      <div className="box">
         <div className="growth-tools-container">
            <div className="widget-localization">
               <div className="title">
                  <h4>Bản địa hóa Widget</h4>
               </div>
               <div className="m-t sm-m-t-0 content">
                  <div className="input-select"><select className=" pd8-i">
                     <option value="vi-VN" selected="">Tiếng Việt</option>
                     <option value="en-US">English</option>
                     <option value="th-TH">ภาษาไทย</option>
                  </select>
                     <div className="svg-next-icon ic-arrow-down">
                     </div>
                  </div>
               </div>
               <div className="m-t sm-m-t-0 note">
                  <div className="text-secondary">Bản địa hóa widgets - dành cho nút 'Gửi tin nhắn' và tin nhắn đầu tiên trong mục
                     'Chat với khách hàng' - bằng cách chọn ngôn ngữ từ danh sách kế bên.<br /> Thiết lập này cũng sẽ được áp
                     dụng cho tất cả các công cụ trừ Facebook Comments, Facebook Ads JS, Facebook Messenger Code. Tiếng Việt
                     sẽ được dùng làm ngôn ngữ mặc định</div>
               </div>
            </div>
            <div className="authorized-website">
               <div className="title">
                  <h4>Ủy quyền Websites</h4>
                  <div className="note">
                     <div className="text-secondary">Trang web mà bạn quản lý.Tối đa 50 websites.</div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default TabGrowtools;